import React from 'react';
import { useTranslation } from 'hooks/useTranslation';
import logger from 'services/logger';
import { getURLWithUTMParameters } from 'components/ShareDialog/utils';
import { ShareMethod } from './ShareMethod';
import { ShareMethodComponent } from './types';

export const ShareMethodEmail: ShareMethodComponent = ({ url, onClick }) => {
  const t = useTranslation();

  const emailBody = encodeURIComponent(getURLWithUTMParameters(url, 'email'));

  function handleClick(event: React.SyntheticEvent) {
    event.preventDefault();
    onClick();
    try {
      const emailSubject = encodeURIComponent(window.document.title);
      window.location.href = `mailto:?subject=${emailSubject}&body=${emailBody}`;
    } catch (e) {
      logger.error(e, "Couldn't initiate share by email");
    }
  }

  return (
    <ShareMethod
      label={t('shareLabelEmail')}
      name="email"
      onClick={handleClick}
    />
  );
};
